<template>
	<div class="container">
		<SvgBgAuth />
		<HeaderDriver
			@openSupportChat="openSupportChat"
			v-if="profile.isDriver"
		/>
		<HeaderStorekeeper
			v-else-if="profile.isStorekeeper"
			@openSupportChat="openSupportChat"
		/>
		<HeaderTrucker
			v-else-if="profile.isTrucker"
			@openSupportChat="openSupportChat"
		/>
		<div
			class="wrapper"
			:style="{ backgroundColor: $router.currentRoute.value.meta.customColorBg || 'transparent' }"
		>
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useChatSupportStore } from '~/store/chatSupport.store';
	import { useProfileStore } from '~/store/profile.store';

	const chatSupportStore = useChatSupportStore();
	const profile = useProfileStore();
	const runtimeConfig = useRuntimeConfig();

	const openSupportChat = () => {
		const link = runtimeConfig.public.telegramChatLink;
		if (link && link !== 'false') {
			window.open(link as string, '_blank');
			return;
		}
		if (chatSupportStore.isShowWidget) {
			chatSupportStore.hiddenWidgetChat();
			return;
		}
		chatSupportStore.showWidgetChat();
	};

	onMounted(() => {
		if (useRuntimeConfig().public.rocketChatLink !== 'false') {
			chatSupportStore.getRocketChat();
		}
	});
</script>
<style lang="scss">
	.rocketchat-widget {
		display: none;
	}
</style>
<style scoped lang="scss">
	.container {
		min-height: 100vh;
		display: grid;
		justify-items: center;
		grid-template-columns: 1fr;
		grid-template-rows: max-content 1fr;
		column-gap: 30px;
		padding: 0px 20px 20px 20px;
		padding-top: env(safe-area-inset-top);

		.wrapper {
			border-radius: 20px;
			max-width: 800px;
			width: 100%;
		}

		.header {
			grid-row: 1/1;
			min-height: 48px;
		}

		.sidebar {
			min-height: calc($full-screen-min-height-default - 15px);
			grid-row: 1/3;
			background: var(--white);
			border-radius: 20px;
			border-top-left-radius: 0;
			border-top-right-radius: 0;
			padding: 25px;

			.ui-button {
				padding: 0;
				width: 100%;
			}
		}
	}
</style>
